export function setThemeColor(color = '#FFFFFF') {
    const meta = document.getElementsByTagName("meta");
    meta["theme-color"].setAttribute(
        "content", color
    );
}